module.exports = __webpack_public_path__ + "img/law-explore.c5d7d81f.jpg";